import http from './http';

export default {
  markComplete(onboardingId) {
    return http().put(`v1/onboarding/${onboardingId}/mark-complete`);
  },
  updateChosenIntegration(onboardingId, data) {
    return http().put(`v1/onboarding/${onboardingId}/chosen-integrations`, data);
  },
}
